import React from 'react'

export default function Cart() {
  const someObject = {}

  return <div>{someObject.someProperty.throw}</div>
}
